import React, { createContext } from 'react';

type IProductContext = {
  recommendedProducts: any[];
  productGroup: object;
  youMayAlsoLikeProducts: any[];
};

export const ProductContext = createContext<IProductContext>({
  recommendedProducts: [],
  productGroup: {},
  youMayAlsoLikeProducts: [],
});

export const ProductContextProvider = ({ children, data }) => {
  return (
    <ProductContext.Provider value={data}>{children}</ProductContext.Provider>
  );
};
